import { EServiceId } from '../../../../types/reducers/publishTerms';
import { ECheckServicePublicationType } from '../../../../services/checkService';
import { IPackage } from '../../../../reducers/v2/publicationPackages/types';

interface IParams {
  publicationType: ECheckServicePublicationType;
  packages: IPackage[];
  serviceId: EServiceId;
}

export const getPackageId = ({ publicationType, packages, serviceId }: IParams): string => {
  const packageServiceId =
    publicationType === ECheckServicePublicationType.PublicationPackage ? EServiceId.paid : serviceId;

  return packages.find(p => p.serviceId === packageServiceId)!.id;
};
